// comeback funnel events for PostHog (project "Paid Leadgen" 522953). Loaded right after ph.js on every storefront page.
// Anonymous: no identify, no typed values. Checkout steps come from the Shopify custom pixel "comeback PostHog"
// (~/clawd/ecom/comeback/pixel/posthog-custom-pixel.js), which reads the same PostHog cookie and cb_attr.
// Same design as Vellomane's vm-funnel.js, with the comeback page's own elements (sections/comeback-offer.liquid).
(function () {
  var path = location.pathname;
  var page = /^\/products\//.test(path) ? "pdp" : path === "/" ? "home" : "other";
  function cap(name, props) {
    props = props || {};
    props.cb_page = page;
    try { window.posthog.capture(name, props); } catch (e) {}
  }

  // Ad attribution. Meta URL tags: utm_campaign = campaign id, utm_term = ad set id, utm_content = ad id.
  // Persisted as super properties (storefront) and first-party cookies (read by the sandboxed checkout pixels).
  var q = new URLSearchParams(location.search);
  var gk = q.get("gclid") ? "gclid" : q.get("gbraid") ? "gbraid" : q.get("wbraid") ? "wbraid" : "";
  if (gk) {
    document.cookie = "cb_gclid=" + encodeURIComponent(JSON.stringify({ k: gk, v: q.get(gk), t: Date.now() })) +
      ";path=/;max-age=7776000;SameSite=Lax";
  }
  if (q.get("utm_term") || q.get("fbclid") || gk) {
    var attr = {
      cb_source: q.get("utm_source") || (gk ? "google" : "facebook"),
      cb_campaign: q.get("utm_campaign") || "",
      cb_adset: q.get("utm_term") || "",
      cb_ad: q.get("utm_content") || "",
      cb_landing: page
    };
    try { window.posthog.register(attr); } catch (e) {}
    document.cookie = "cb_attr=" + encodeURIComponent(JSON.stringify(attr)) + ";path=/;max-age=2592000;SameSite=Lax";
  }

  function scrollPct() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    return h > 0 ? Math.min(100, Math.round((window.scrollY / h) * 100)) : 100;
  }
  function planOf(input) {
    var l = input && input.closest("label");
    var nm = l && l.querySelector(".cb-nm"), pr = l && l.querySelector(".cb-pr b");
    return { plan: nm ? nm.textContent.trim() : "", price: pr ? pr.textContent.trim() : "" };
  }
  function subOn() { var b = document.getElementById("cb-subBox"); return !!(b && b.checked && !b.closest("[hidden]")); }
  function ready(fn) { if (document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    // Scroll depth milestones (once each per page view).
    var marks = [25, 50, 75, 100], hit = {};
    window.addEventListener("scroll", function () {
      var p = scrollPct();
      for (var i = 0; i < marks.length; i++) {
        var m = marks[i];
        if (p >= (m === 100 ? 97 : m) && !hit[m]) { hit[m] = 1; cap("cb_scroll", { depth: m }); }
      }
    }, { passive: true });

    // Section reached: each h2 on the page (week timeline, problem, kit, reviews, comparison, guarantee, FAQ, offer).
    var secs = document.querySelectorAll(".cb h2");
    if (secs.length && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target, idx = Array.prototype.indexOf.call(secs, el);
          cap("cb_section_viewed", { section: idx + 1, title: (el.textContent || "").trim().slice(0, 70) });
          io.unobserve(el);
        });
      }, { threshold: 0.6 });
      secs.forEach(function (el) { io.observe(el); });
    }

    // Bucket 1 of the Google ladder: the plans box came on screen far enough to show the Buy button.
    // Published as a Shopify custom event so the sandboxed "comeback Google Ads" pixel can send conversion
    // 7843580342. Once per page view; Google counts it once per ad click anyway.
    var buyBtn = document.getElementById("cb-buy");
    if (buyBtn && "IntersectionObserver" in window) {
      var oo = new IntersectionObserver(function (entries) {
        if (!entries.some(function (en) { return en.isIntersecting; })) return;
        oo.disconnect();
        cap("cb_plans_seen", {});
        try { window.Shopify.analytics.publish("cb_plans_seen", { page: page }); } catch (e) {}
      }, { threshold: 0.5 });
      oo.observe(buyBtn);
    }

    // Buy errors: the section shows #cb-err when the cart call fails.
    var err = document.getElementById("cb-err");
    if (err && "MutationObserver" in window) {
      new MutationObserver(function () {
        if (!err.hidden && err.textContent.trim()) cap("cb_buy_error", { message: err.textContent.trim().slice(0, 80) });
      }).observe(err, { attributes: true, attributeFilter: ["hidden"] });
    }
  });

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href="#cb-offer"]');
    if (a) {
      var where = a.id === "cb-heroCta" ? "hero" : a.closest("#cb-sticky") ? "sticky" : a.classList.contains("cb-cart") ? "cart_icon" : "other";
      cap("cb_cta_clicked", { cta: where, depth: scrollPct() });
      return;
    }
    if (t.closest("#cb-buy")) {
      var sel = document.querySelector('input[name="cb-plan"]:checked');
      var p = planOf(sel);
      cap("cb_buy_clicked", { plan: p.plan, price: p.price, subscribe: subOn(), depth: scrollPct() });
      return;
    }
    if (t.closest('[name="checkout"], a[href^="/checkout"]')) { cap("cb_checkout_clicked", {}); return; }
  }, true);

  // Plan choice and the 1 Kit subscribe box.
  document.addEventListener("change", function (e) {
    var el = e.target;
    if (!el) return;
    if (el.name === "cb-plan") { var p = planOf(el); cap("cb_plan_selected", { plan: p.plan, price: p.price }); return; }
    if (el.id === "cb-subBox") cap("cb_subscribe_toggled", { on: el.checked });
  }, true);

  // FAQ opened (details/summary).
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (d && d.tagName === "DETAILS" && d.open) {
      var s = d.querySelector("summary");
      cap("cb_faq_opened", { question: s ? s.textContent.trim().slice(0, 70) : "" });
    }
  }, true);
})();
